((document, Drupal) => {
  "use strict";

  Drupal.behaviors.mediaEmbed = {
    attach: function (context) {
      if (!document.querySelector(".media-embed.swiper")) return;
      const mediaEmbeds = document.querySelectorAll(".media-embed");

      mediaEmbeds.forEach((mediaEmbed, index) => {
        return new Swiper(mediaEmbed, {
          autoHeight: "auto",
          loop: true,

          // Navigation arrows
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          on: {
            slideChange: function (e) {
              e.slides.forEach((slide) => {
                const iframe = slide.querySelector("iframe");
                if (iframe) {
                  const src = iframe.getAttribute("src");
                  iframe.setAttribute("src", src);
                }
              });
            },
          },
        });
      });
    },
  };
})(document, Drupal);
